import React from "react";

export default function DownArrow() {
  return (
    <svg viewBox="0 0 42 42">
      <path
        d="M18.097.29h5.123l.057 33.304 14.347-14.46 3.53 3.53L22.537 41.28h-3.643L.277 22.663l3.7-3.7 14.177 14.176-.057-32.85Z"
        fill="currentColor"
      />
    </svg>
  );
}
